import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AppInitializerService {
  private static readonly REQUIRED_SCRIPTS = [
    { src: './assets/plugins/hermes.js', global: 'hermes' }
  ];

  async initializeApp(): Promise<void> {
    try {
      await this.loadRequiredScripts();
      this.verifyInitialization();
    } catch (error) {
      console.error('Failed to initialize application:', error);
      throw error;
    }
  }

  private loadRequiredScripts(): Promise<void[]> {
    const scriptPromises = AppInitializerService.REQUIRED_SCRIPTS.map(script => 
      this.loadScript(script.src)
    );
    return Promise.all(scriptPromises);
  }

  private loadScript(src: string): Promise<void> {
    return new Promise((resolve, reject) => {
      // Check if script is already loaded
      if (document.querySelector(`script[src="${src}"]`)) {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = src;
      script.type = 'text/javascript';
      
      script.onload = () => resolve();
      script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
      
      document.head.appendChild(script);
    });
  }

  private verifyInitialization(): void {
    AppInitializerService.REQUIRED_SCRIPTS.forEach(script => {
      if (!(window as any)[script.global]) {
        throw new Error(`Required global '${script.global}' not found after script initialization`);
      }
    });
  }
} 